import { Injectable } from '@angular/core';

import { DataService } from '../network/data.service';
import { ComplexityEstimationResult } from './complexity-estimation-result';
import { SelectedDimensionValsModel } from './selected-dimension-vals-model';

@Injectable()
export class ComplexityMngtService {
    constructor(private dataService: DataService) {
    }

    public getComplexityEstimation (projectId: string): Promise<ComplexityEstimationResult> {
        return this.dataService.get<ComplexityEstimationResult>('complexity/estimation/' + projectId);
    }

    public removeColumn(projectId: string, i: number) {
        return this.dataService.post<ComplexityEstimationResult>('complexity/removeColumn', {
            projectId: projectId,
            columnIndex: i,
        });
    }

    public unremoveColumn(projectId: string, i: number) {
        return this.dataService.post<ComplexityEstimationResult>('complexity/unremoveColumn', {
            projectId: projectId,
            columnIndex: i,
        });
    }
    
    public getTopVals(projectId: string, columnName: string): Promise<SelectedDimensionValsModel> {
        return this.dataService.get<SelectedDimensionValsModel>(`complexity/TopVals?projectId=${projectId}&columnName=${columnName}`);
    }

    public saveTopVals(projectId: string, columnName: string, values: string[]) {
        return this.dataService.post('complexity/saveTopVals', {
            projectId: projectId,
            columnName: columnName,
            values: values,
        });
    }

    public removeColumnCompression(projectId: string, dimIndex: number): Promise<ComplexityEstimationResult> {
        return this.dataService.post<ComplexityEstimationResult>('complexity/removeColumnCompression', {
            projectId: projectId,
            columnIndex: dimIndex,
        });
    }
}